import { render, staticRenderFns } from "./CaseUploadsDirModal.vue?vue&type=template&id=567d08a6"
import script from "./CaseUploadsDirModal.vue?vue&type=script&lang=js"
export * from "./CaseUploadsDirModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports